import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { useAuth } from '../hooks/useAuth';
import '../styles/global.css';

export default function LandlordLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/landlord/login', data);
      login(res.data.token, res.data.landlord, 'landlord');
      navigate('/landlord/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="topbar">
        <div className="topbar-logo">
          <div className="topbar-logo-dot" />
          Affordable Telecom LLC
        </div>
      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 420 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <h1 style={{ fontSize: 26, fontWeight: 800, color: 'var(--navy)', marginBottom: 6 }}>
              Landlord Portal
            </h1>
            <p style={{ color: 'var(--text-sub)', fontSize: 14 }}>
              View your portfolio, revenue, and tenant activity
            </p>
          </div>
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label className="form-label" htmlFor="landlord-email">Email address</label>
                  <input id="landlord-email" type="email" className={`form-input${errors.email ? ' error' : ''}`}
                    placeholder="you@company.com" {...register('email', { required: true })} />
                  {errors.email && <div className="form-error">Email is required</div>}
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="landlord-password">Password</label>
                  <input id="landlord-password" type="password" className={`form-input${errors.password ? ' error' : ''}`}
                    placeholder="Your password" {...register('password', { required: true })} />
                  {errors.password && <div className="form-error">Password is required</div>}
                </div>
                <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                  {loading ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Signing in...</> : 'Sign In to Landlord Portal'}
                </button>
              </form>
            </div>
          </div>
          <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--text-sub)' }}>
            Tenant?{' '}<Link to="/login" style={{ color: 'var(--teal)', fontWeight: 600 }}>Sign in here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
